export const TRIGGER_CONSTANTS = {
  MAX_DESCRIPTION_LENGTH: 180,
  VALID_NAME_REGEX: /^[a-zA-Z0-9 _:-]+$/
};

export const VALIDATION_MESSAGES = {
  NAME_REQUIRED: "Workflow name is required",
  NAME_INVALID_CHARACTERS: "You can use alphanumeric characters, spaces, underscore (_), hyphen (-), and colon (:)",
  NAME_ALREADY_EXISTS: "This name already exists, try another name or add a variation to it",
  DESCRIPTION_TOO_LONG: "Description must be under 180 characters",
}; 